import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVolumeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M514 116Q514 100 505 91.5 496 83 482 83 463 83 450 96L188 336 52 336Q35 336 27.5 343.5 20 351 20 368L20 624Q20 642 28 650 36 658 54 658L192 658 448 900Q463 918 482 918 495 918 504.5 907.5 514 897 514 878ZM783 724Q855 678 890 625 925 572 925 500 925 428 890 375 855 322 783 276L832 216Q920 274 960 342 1000 410 1000 500 1000 589 959.5 657 919 725 832 784ZM649 604Q685 591 709 563.5 733 536 733 500 733 464 709 436.5 685 409 649 396L694 342Q746 363 774 405 802 447 802 500 802 553 774 595 746 637 694 658Z" })
});
export default SvgVolumeIcon;
